module.exports = __webpack_public_path__ + "static/media/pp-shield-short.379e3e81.svg";